import {React,useEffect,useState } from 'react';
import { NavLink,useNavigate } from 'react-router-dom';
import {
  UserCircle,
  Briefcase,
  Calendar,
  Zap,
  Bell,
  Settings,
  LogOut,Star,User,CreditCard,Users
} from 'lucide-react';
import { Nav, Container } from 'react-bootstrap';



import  fetchUserJogetProfileApi  from '../../../services/api';
import  {useAuth}  from '../../../context/AuthContext';
import ChangePasswordPage from '../../dashboard/ChangePasswordPage';
import DirectorProfilePage from './DirectorProfilePage';

import './DirectorSidebar.css'

const DirectorSidebar = () => {

  
  
    const [applications, setApplications] = useState([]);
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [showDrawer, setShowDrawer] = useState(false);
    const handleClose = () => setShowDrawer(false);
      const [profile, setProfile] = useState({
        c_yourName: '',
        role: '',
        isVerified: false,
        photoURL: ''
      });
    
    const handleLogout = () => {
      logout();
      handleClose();
      navigate('/login');
    };  

      

  // USER DATA (Copied logic from TalentSidebar)
  const displayName = user?.full_name || 'Director';
  const displayRole = user?.role || 'Director';
  const profileImageUrl = user?.profile_image_url || '';

  // FALLBACK AVATAR
  const defaultAvatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName)}&background=d90429&color=fff&size=150`;

  const imageSource = profileImageUrl ? profileImageUrl : defaultAvatar;

  return (
    <div className="dir-sidebar py-4">

      {/* 🔥 CARD 1 (PROFILE + MENU + LOGOUT) */}
      <div className="dir-main-card mt-5">

        {/* PROFILE */}
       
       <div className="sidebar-profile text-center mb-4">

          <img
            src={imageSource}
            alt="Casting Director"
            className="td-profile-img"
            onError={(e) => {
              e.target.src = defaultAvatar;
            }}
          />

          <h4>{displayName}</h4>

          <p>{displayRole}</p>

        </div>

        {/* MENU */}
         <div className="dir-sidebar-nav">
        
                  <NavLink
                    to="/dashboard/overview"
                    className={({ isActive }) =>
                      isActive ? "dir-menu-item active" : "dir-menu-item"
                    }
                  >
                    <User size={18} /> Dashboard
                  </NavLink>
                  <NavLink
                    to="/dashboard/profile"
                    className={({ isActive }) =>
                      isActive ? "dir-menu-item active" : "dir-menu-item"
                    }
                  >
                    <UserCircle size={16} /> Profile
                  </NavLink>
        
        
        
        
                  <NavLink
                    to="/dashboard/projects"
                    className={({ isActive }) =>
                      isActive ? "dir-menu-item active" : "dir-menu-item"
                    }
                  >
                    <Briefcase size={18} /> Projects
                  </NavLink>
        
        
                  <NavLink
                    to="/dashboard/roles"
                    className={({ isActive }) =>
                      isActive ? "dir-menu-item active" : "dir-menu-item"
                    }
                  >
                    <Users size={18} /> Manage Roles
                  </NavLink>
        
        
                  <NavLink
                    to="/dashboard/manage-applications"
                    className={({ isActive }) =>
                      isActive ? "dir-menu-item active" : "dir-menu-item"
                    }
                  >
                    <Users size={16} /> Audition
                  </NavLink>
        
        
                  <NavLink
                    to="/dashboard/transaction-history"
                    className={({ isActive }) =>
                      isActive ? "dir-menu-item active" : "dir-menu-item"
                    }
                  >
                    <CreditCard size={16} /> Billing
                  </NavLink>
        
                </div>
        

        {/* LOGOUT */}
        <div className="logout" onClick={handleLogout}>
          <LogOut size={16} /> Sign Out
        </div>


      </div>

    
      
      <div className="dir-pro-card">
  
  <div className="pro-title ">
    <Star size={16} />
    <span>Pro Features</span>
  </div>

  <p className="pro-text">
    Unlock AI self-tape scoring and priority role matching.
  </p>

  <button className="pro-btn">
    Upgrade Now
  </button>

</div>

    </div>
  );
};

export default DirectorSidebar;